export const TIENDEO = "tiendeo";
